'use client';

import React from 'react';
import { useAuth } from 'src/context/auth';
import { Tags } from 'src/components';

const ListNameCell = ({ row }) => {
  const { user } = useAuth();
  if (!row || !row.name) return null;

  const href = row?.owner?.id === user?.id
    ? `/lists/my/${row?.id}`
    : `/lists/team/${row?.id}`;

  const tag = {
    id: row?.id,
    label: row?.name,
    fullText: row?.name,
    href,
    FormattedText: () => <span>{row?.name}</span>,
    bgColor: row?.bgColor,
  };

  return <Tags tags={[tag]} tagType="list" />;
};

export default ListNameCell;
